<template #content>

    <Dialog :visible="visible" @update:visible="updateVisible" header="Detalhes do Log" modal :closable="true"
        :dismissable-mask="true" @show="onShow" @hide="onHide" class="fixed-width-dialog">

        <template #default>
            <div>
                <p v-if="selectedLog">Operação: {{ selectedLog.operacao }}</p>
                <p v-if="selectedLog">Tabela: {{ selectedLog.table }}</p>
                <p v-if="selectedLog">ID Tabela: {{ selectedLog.table_id }}</p>

                <div v-if="selectedLog && selectedLog.objeto" style="margin-top: 1em;">
                    <h4>Conteúdo:</h4>
                    <ul v-for="(value, key) in parseContentLog(selectedLog.objeto)" :key="key"
                        style="list-style: none;">
                        <li><strong>{{ key }}</strong>:</li>
                        <ul>
                            <li v-if="value.old"><strong>Antigo:</strong> {{ value.old }}</li>
                            <li v-if="value.new"><strong>Novo:</strong> {{ value.new }}</li>
                        </ul>
                    </ul>
                </div>

                <p v-if="selectedLog">Data/Hora: {{ momentTransform(selectedLog.created_at) }}</p>
                <p v-if="selectedLog">Usuário: {{ selectedLog.usuario }}</p>
            </div>
        </template>
    </Dialog>

</template>
<script>
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DatePicker from 'primevue/datepicker';
import Dialog from 'primevue/dialog';
import Moment from 'moment';

import Log from '@/service/log.js';

import Filter from '@/utils/Filter.js';

export default {
    components: {
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        Dialog,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        InputNumber,
        DatePicker,

    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Object,
            required: false,
            default: () => null,
        },
    },
    data() {
        return {
            selectedLog: this.data,
            isLoading: false,
            visibleForm: false,
        }
    },
    watch: {
        data(newData) {
            this.selectedLog = newData;
        },
    },
    methods: {
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onShow() {
            this.selectedLog = { ...this.data };
        },
        onHide() {
            // ...
        },
        parseContentLog(content) {
            try {
                return JSON.parse(content);
            } catch (error) {
                return {};
            }
        },
        momentTransform(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },

    }
}
</script>

<style>
.fixed-width-dialog {
    width: 500px !important;
    max-width: 500px !important;
}
</style>
